import { mapCollection } from '../../utils/collection.utils';
import { Sector } from '../sector';

export class SectorBuilder {
  static fromJson(json) {
    return (json)
      ? new Sector(
        json.hash,
        json.title
      )
      : null;
  }

  static fromList(list) {
    return (Array.isArray(list)) ? mapCollection(SectorBuilder.fromJson, list) : [];
  }
}
